import createIcon from '../../createIcon';

/**
 * @component @name TabletMac
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMEg1QzMuNjIgMCAyLjUgMS4xMiAyLjUgMi41VjIxLjVDMi41IDIyLjg4IDMuNjIgMjQgNSAyNEgxOUMyMC4zOCAyNCAyMS41IDIyLjg4IDIxLjUgMjEuNVYyLjVDMjEuNSAxLjEyIDIwLjM4IDAgMTkgMFpNMTIgMjNDMTEuMTcgMjMgMTAuNSAyMi4zMyAxMC41IDIxLjVDMTAuNSAyMC42NyAxMS4xNyAyMCAxMiAyMEMxMi44MyAyMCAxMy41IDIwLjY3IDEzLjUgMjEuNUMxMy41IDIyLjMzIDEyLjgzIDIzIDEyIDIzWk0xOS41IDE5SDQuNVYzSDE5LjVWMTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TabletMac = createIcon('TabletMac', [
  [
    'path',
    {
      d: 'M19 0H5C3.62 0 2.5 1.12 2.5 2.5V21.5C2.5 22.88 3.62 24 5 24H19C20.38 24 21.5 22.88 21.5 21.5V2.5C21.5 1.12 20.38 0 19 0ZM12 23C11.17 23 10.5 22.33 10.5 21.5C10.5 20.67 11.17 20 12 20C12.83 20 13.5 20.67 13.5 21.5C13.5 22.33 12.83 23 12 23ZM19.5 19H4.5V3H19.5V19Z',
      key: 'x3bvea',
    },
  ],
]);

export default TabletMac;
